module.exports = "https://r.zoocdn.com/_next/static/images/mobile-8c194a25f3470ae16d3630c19266b99c.jpeg";